export enum ActiveTab {
  All = "All",
  NotSubmitted = "NotSubmitted",
  PartiallySubmitted = "PartiallySubmitted",
  Submitted = "Submitted",
  Approved = "Approved",
  ApprovedConditionally = "ApprovedConditionally",
  Declined = "Declined",
  Canceled = "Canceled",
  OnHold = "OnHold"
}
export const newOrder = [
  "criteria",
  "applicants",
  "property",
  "state",
  "property_group",
  "unit",
  "unit_type",
  "started_at",
  "last_note",
  "submitted_at",
  "desired_move_in_date",
  "updated_at",
  "assigned_to",
  "status"
];
